export const eur = (v, d = 2) =>
  v == null
    ? "–"
    : new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: d, maximumFractionDigits: d }).format(v);

export const num = (v, d = 2) =>
  v == null ? "–" : new Intl.NumberFormat("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d }).format(v);

export const pct = (v) => {
  if (v == null) return "–";
  const r = Math.round(v * 100) / 100 || 0;
  return `${r > 0 ? "+" : ""}${num(r, 2)} %`;
};

export const dt = (iso) =>
  iso ? new Date(iso).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" }) : "–";

export const ROLE_LABEL = { admin: "Administrator", member: "Benutzer", pending: "Gesperrt / ohne Freigabe" };

export const unitDigits = (u) => ({ g: 2, t: 0 }[u] ?? 3);

export const DIRECTION_LABEL = { above: "steigt auf ≥", below: "fällt auf ≤" };

export const KIND_LABEL = { alarm: "Alarm", test: "Manuell", wochenbericht: "Wochenbericht", wochenbericht_manuell: "Wochenbericht (manuell)" };

export const STATUS_STYLE = {
  gesendet: "bg-emerald-50 text-emerald-700 border-emerald-200",
  fehler: "bg-red-50 text-red-700 border-red-200",
  "nicht gesendet": "bg-amber-50 text-amber-800 border-amber-200",
};
